module.exports = __webpack_public_path__ + "img/newsImg9.5625bf91.png";